export default __webpack_public_path__ + "static/media/image-1.217d6f3c.jpg";